export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14628.4337b61b.jpg";